<template>
  <div/>
</template>

<script>
import { getDateOfDay,getDateStr,getYesterdayArr,getCurMonthRange } from '@/utils/index'
export default {
  name: 'Testing',
  created () {
    console.log(getDateOfDay(-7))
  }
}
</script>

<style scoped>

</style>
